/** Accept Firestore Timestamp, Date, millis number, unix seconds, ISO string, or { seconds, nanoseconds? }. */
export function coerceTimestampMs(v) {
  if (v == null) return null;
  if (typeof v.toMillis === "function") return v.toMillis();
  if (v instanceof Date) return v.getTime();
  if (typeof v === "object") {
    const sec =
      typeof v.seconds === "number"
        ? v.seconds
        : typeof v._seconds === "number"
          ? v._seconds
          : null;
    if (sec != null) return sec * 1000;
  }
  if (typeof v === "number") {
    if (v > 1e11) return v;
    if (v > 1e9) return v * 1000;
  }
  const t = new Date(v).getTime();
  return Number.isNaN(t) ? null : t;
}

export function coerceTimestampDate(v) {
  const ms = coerceTimestampMs(v);
  return ms == null ? null : new Date(ms);
}

/** GA4 property reports dates in property-local time (UTC+2 in our backfill scripts). */
export const GA4_PROPERTY_TZ_OFFSET_HOURS = 2;

/** Start of GA4 local day — matches `ga4LocalDayRangeUtc` in functions/ga4Heuristic.js. */
export function ga4DateStartMs(yyyymmdd, tzOffsetHours = GA4_PROPERTY_TZ_OFFSET_HOURS) {
  const s = String(yyyymmdd || "").trim();
  if (s.length !== 8) return null;
  const y = Number(s.slice(0, 4));
  const m = Number(s.slice(4, 6)) - 1;
  const day = Number(s.slice(6, 8));
  if (!Number.isFinite(y) || !Number.isFinite(m) || !Number.isFinite(day)) return null;
  return Date.UTC(y, m, day, 12, 0, 0) - tzOffsetHours * 3600000;
}
